//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getShopingMade,
  getShopingGold,
  putDeleteCart,
} from "./../../service/index";
import { go } from "./../../util/router";
import { zdsCategory } from "./../../config/env";
export default {
  data() {
    return {
      ZSQ: { List: [] },
      ZSJ: { List: [] },
      currCategory: "",
      zdsCategory: zdsCategory,
    };
  },
  components: {},
  created() {
    let vm = this;
    vm.currCategory = this.$route.params.type;
    if (vm.currCategory === zdsCategory.ZSQ) {
      vm.getShopMade();
    } else if (vm.currCategory === zdsCategory.ZSJ) {
      vm.getShopGold();
    }
  },
  mounted() {},
  watch: {
    "": function (to, from) {},
  },
  methods: {
    getShopMade() {
      let vm = this;
      getShopingMade(this.$route.params.id, (result) => {
        if (result.code === "1") {
          vm.ZSQ.List = JSON.parse(result.data);
        }
      });
    },
    getShopGold() {
      let vm = this;
      getShopingGold(this.$route.params.id, (result) => {
        if (result.code === "1") {
          vm.ZSJ.List = JSON.parse(result.data);
        }
      });
    },
    del(idx, id) {
      let vm = this;
      let params = this.$route.params;
      let pData = {
        CartDetails: [
          {
            BigZDL: params.type,
            CarOid: params.cid,
            EntriesOids: [{ Oid: id }],
          },
        ],
      };
      console.log(JSON.stringify(pData));
      putDeleteCart(pData, (result) => {
        if (result.code === "1") {
          if (params.type === vm.zdsCategory.ZSQ) {
            vm.ZSQ.List.splice(idx, 1);
          } else if (params.type === vm.zdsCategory.ZSJ) {
            vm.ZSJ.List.splice(idx, 1);
          }
        }
      });
    },
    add() {
      go(
        "/outbatchdetail/" + this.currCategory + "/" + this.$route.params.id,
        this.$router
      );
    },
    goCart() {
      history.go(-1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/page/shopcart/outbatch.vue